import styled from '@emotion/styled';
import { memo } from 'react';
import { fill_horizontal_all_center } from '~/modules/AppLayout/FlexGridCss';
export const StockForum_Topbar = memo(function StockForum_Topbar() {
    return (<styleds.container>
      <span>免費諮詢專線 0800-000-000</span>
      <span>公司資訊</span>
      <span>軟體下載</span>
      <span>會員(訂閱)專區</span>
    </styleds.container>);
});
const styleds = {
    container: styled.div `
    ${fill_horizontal_all_center};
    padding: 0 16px;
    justify-content: end;
    gap: 16px;
    background-color: #459ada;
    font-weight: bold;
    color: #fff;
    border-bottom: 1px solid #cccccc;
  `,
};
